"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const exclamationcircle = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    "aria-labelledby": (title ? "title-exclamationcircle" : '') + (description ? " desc-exclamationcircle" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-exclamationcircle"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-exclamationcircle"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    id: "ulta_circle_exclamation",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12,-1.77635684e-15 C18.627417,-1.77635684e-15 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,-1.77635684e-15 12,-1.77635684e-15 Z M12,1.5 C6.20101013,1.5 1.5,6.20101013 1.5,12 C1.5,17.7989899 6.20101013,22.5 12,22.5 C17.7989899,22.5 22.5,17.7989899 22.5,12 C22.5,6.20101013 17.7989899,1.5 12,1.5 Z M12,15.75 L12.1225811,15.7566013 C12.6862391,15.8176801 13.125,16.295101 13.125,16.875 C13.125,17.4963203 12.6213203,18 12,18 C11.3786797,18 10.875,17.4963203 10.875,16.875 C10.875,16.295101 11.3137609,15.8176801 11.8774189,15.7566013 L12,15.75 Z M12,4.5 C12.3796958,4.5 12.693491,4.78215388 12.7431534,5.14822944 L12.75,5.25 L12.75,13.5 C12.75,13.9142136 12.4142136,14.25 12,14.25 C11.6203042,14.25 11.306509,13.9678461 11.2568466,13.6017706 L11.25,13.5 L11.25,5.25 C11.25,4.83578644 11.5857864,4.5 12,4.5 Z",
    id: "\uD83C\uDF08-Icon-Color",
    fill: "#000000"
  })));
};
var _default = exports.default = exclamationcircle;